import apiClient from '../client';
import { ApiResponse } from '../types/common.types';
import {
  DisbursementInitiationRequest,
  Disbursement,
  DisbursementRetryRequest,
  PendingDisbursementsResponse,
} from '../types/disbursement.types';

/**
 * Disbursement API endpoints
 */
export const disbursementsApi = {
  /**
   * Initiate disbursement
   */
  initiate: async (data: DisbursementInitiationRequest): Promise<{ disbursementStatus: string; loanId: string; transactionId: string }> => {
    const response = await apiClient.post<ApiResponse<{ disbursementStatus: string; loanId: string; transactionId: string }>>(
      '/disbursements/initiate',
      data
    );
    if (!response.data.data) {
      throw new Error('No data received from server');
    }
    return response.data.data;
  },

  /**
   * Get disbursement status
   */
  getStatus: async (disbursementId: string): Promise<Disbursement> => {
    const response = await apiClient.get<ApiResponse<{ disbursement: Disbursement }>>(
      `/disbursements/${disbursementId}`
    );
    if (!response.data.data) {
      throw new Error('No data received from server');
    }
    return response.data.data.disbursement;
  },

  /**
   * Get pending disbursements
   */
  getPending: async (): Promise<Disbursement[]> => {
    const response = await apiClient.get<PendingDisbursementsResponse>('/disbursements/pending');
    return response.data.disbursements || [];
  },

  /**
   * Retry failed disbursement
   */
  retry: async (disbursementId: string, data: DisbursementRetryRequest): Promise<{ success: boolean }> => {
    const response = await apiClient.post<ApiResponse>(
      `/disbursements/${disbursementId}/retry`,
      data
    );
    return { success: response.data.success };
  },
};
